export enum Role {
  SystemAdmin = 1,
  DistrictAdmin = 2,
  User = 3,
}
